import { axiosInstance } from "../apiConfig";

export const getDeviceId = () => {
  let deviceId = localStorage.getItem("deviceId");
  if (!deviceId) {
    deviceId = `web-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem("deviceId", deviceId);
  }
  return deviceId;
};

const authHeaders = () => ({
  "X-System-Name": localStorage.getItem("systemName") || "",
  "X-Auth-Token": localStorage.getItem("authToken") || "",
  "X-Device-Id": getDeviceId(),
  "Content-Type": "application/json",
});

export const authSyncAPI = {
  // login requires only device header + body
  login: async ({ systemName, password }) => {
    const res = await axiosInstance.post(
      `/api/auth-sync/login`,
      { systemName, password },
      {
        headers: {
          "X-Device-Id": getDeviceId(),
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  },

  resume: async () => {
    const res = await axiosInstance.post(
      `/api/auth-sync/resume`,
      {},
      { headers: authHeaders() }
    );
    return res.data;
  },

  syncAck: async () => {
    const res = await axiosInstance.post(
      `/api/auth-sync/syncAck`,
      {},
      { headers: authHeaders() }
    );
    return res.data;
  },

  syncSnapshot: async (snapshot) => {
    const res = await axiosInstance.post(
      `/api/auth-sync/syncSnapshot`,
      { snapshotData: snapshot, updatedAt: new Date().toISOString() },
      { headers: authHeaders() }
    );
    return res.data;
  },

  logout: async () => {
    const res = await axiosInstance.post(
      `/api/auth-sync/logout`,
      {},
      { headers: authHeaders() }
    );
    return res.data;
  },
};
